interface RoleSelectorProps {
  value: string
  onChange: (role: string) => void
  disabled?: boolean
  className?: string
}

const ROLES = [
  { value: 'tenant_admin', label: 'Admin', description: 'Full access to all features' },
  { value: 'member', label: 'Member', description: 'View and use profiles' },
]

export default function RoleSelector({
  value,
  onChange,
  disabled = false,
  className = '',
}: RoleSelectorProps) {
  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      className={`input ${disabled ? 'bg-gray-100 cursor-not-allowed' : ''} ${className}`}
    >
      {ROLES.map((role) => (
        <option key={role.value} value={role.value}>
          {role.label}
        </option>
      ))}
    </select>
  )
}

export function RoleBadge({ role }: { role: string }) {
  const isAdmin = role === 'tenant_admin'

  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
        isAdmin
          ? 'bg-personic-100 text-personic-800'
          : 'bg-gray-100 text-gray-800'
      }`}
    >
      {isAdmin ? 'Admin' : 'Member'}
    </span>
  )
}
